import { collection, getDocs } from 'firebase/firestore';
import { useFirestore } from 'reactfire';
import { useState } from 'react';

import { Button } from '@mui/material';

import { BackupCircularProgress } from '../../styled/Backup.styled';

import { getFormattedDate } from '../../utils/dateFormat';
import { exportCSV } from '../../utils/ExportData';

import { ExportData } from '../../types';

const BackupButton = () => {
  const firestore = useFirestore();

  const [loading, setLoading] = useState(false);

  const handleExportCSV = async () => {
    try {
      setLoading(true);
      const snapshot = await getDocs(collection(firestore, 'changeRequests'));
      const data: ExportData = snapshot.docs.map((doc) => ({
        id: doc.id,
        recordId: doc.data().recordId,
        userId: doc.data().userId,
        createdAt: getFormattedDate(doc.data().createdAt),
        requestType: doc.data().requestType,
        status: doc.data().status,
        rowsCount: doc.data().rowsCount,
        paymentAmount: doc.data().paymentAmount,
        paymentDate: getFormattedDate(doc.data().paymentDate),
        docs: doc.data().docs,
        comment: doc.data().comment,
      }));

      await exportCSV(data);
      setLoading(false);
    } catch (error) {
      console.error('Export failed', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button onClick={handleExportCSV} disabled={loading}>
      {loading && <BackupCircularProgress size={18} color="inherit" />}
      Make backups
    </Button>
  );
};

export default BackupButton;
